export default {
  common: {
    search: "搜索",
    confirm: "确认",
    cancel: "取消",
    phone: "电话",
    location: "地点",
  },
  login: {
    title: "登录",
    username: "用户名",
  },
};
